// Knowledge Filer admin API — read-only window onto the nightly filer's runs,
// writes, cost and done-ledger (app/routes/knowledge_filer.py).
import api from './api';

const BASE = '/admin/knowledge-filer';

export interface FilerStatus {
  enabled: boolean;
  model: string;
  max_items: number;
  backfill_since: string;
  timeout_seconds: number;
  schedule_utc: string;
}

export interface FilerWrite {
  server_id: string;
  tool: string;
  source_id: string | null;
  ok: boolean | null;
  headline: string;
  result: string;
}

export interface FilerRunSummary {
  id: string;
  status: string;
  model: string;
  offered: number;
  writes: number;
  writes_ok: number;
  tool_calls: number;
  cost_usd: number | null;
  cost_per_item: number | null;
  conversation_id: string | null;
  error: string | null;
  started_at: string;
  finished_at: string | null;
  duration_seconds: number | null;
}

export interface FilerRunDetail extends FilerRunSummary {
  offered_items: Array<{ source_kind: string; source_id: string; title: string | null; fingerprint?: string }>;
  write_rows: FilerWrite[];
  agent_text: string | null;
}

export interface FilerRunList {
  items: FilerRunSummary[];
  total_cost_usd: number;
  total_offered: number;
  total_writes_ok: number;
}

export interface LedgerRow {
  source_kind: string;
  source_id: string;
  title: string | null;
  entries_written: number;
  filed_at: string;
  run_id: string;
  content_fingerprint: string | null;
}

export interface LedgerList {
  items: LedgerRow[];
  total: number;
}

export const knowledgeFilerApi = {
  async status(): Promise<FilerStatus> {
    const r = await api.get<FilerStatus>(`${BASE}/status`);
    return r.data;
  },
  async runs(limit = 30): Promise<FilerRunList> {
    const r = await api.get<FilerRunList>(`${BASE}/runs`, { params: { limit } });
    return r.data;
  },
  async run(id: string): Promise<FilerRunDetail> {
    const r = await api.get<FilerRunDetail>(`${BASE}/runs/${id}`);
    return r.data;
  },
  async ledger(limit = 100): Promise<LedgerList> {
    const r = await api.get<LedgerList>(`${BASE}/ledger`, { params: { limit } });
    return r.data;
  },
};
